import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Pagination,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  IconButton,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { Cross } from "../../../../shared/assets/icons";
import axios from "axios";
import Styles from "../../../../styles/vendorDashboard.module.css";
import Swal from "sweetalert2";
import IpRejectDialog from "./IpRejectDialog";
import IpReasonDialog from "./IpReasonDialog";
import { MoreVert } from "@mui/icons-material";
import BlockIcon from "@mui/icons-material/Block";
import Decrypt from "../../../../shared/utils/Decrypt";
import styles from "../../../../styles/adminPortal.module.css";
import FormatTimestamp from "../../../../helperFunctions/FormatDateTimestamp";
import CapitalizeFirstLetter from "../../../../shared/utils/CapitalizeFirstLetter";
import GlobalButton from "../../../../shared/utils/GlobalButton";

const columns = [
  {
    field: "serial",
    headerName: "NO. ",
    width: 50,
  },
  { field: "date", headerName: "Slot Date", width: 100 },
  { field: "timeFrom", headerName: "Time From", width: 120 },
  { field: "timeTo", headerName: "Time To", width: 100 },
  { field: "address", headerName: "Address", width: 160 },

  { field: "name", headerName: "IP Name", width: 100 },
  { field: "aadhaarCard", headerName: "Aadhaar No", width: 130 },
  { field: "phone", headerName: "Phone Number", width: 140 },
  { field: "gender", headerName: "Gender", width: 80 },
  { field: "document", headerName: "Test Document", width: 140 },
  { field: "action", headerName: "Test Status ", width: 140 },
];
var oldData = [];

const ViewSlotsInstallationPartner = ({ setSlotModalView, slotModalView }) => {
  console.log(slotModalView);
  const serverURL = process.env.REACT_APP_URL;
  const [pageSize, setPageSize] = useState(20);
  const pageSizeOptions = [1, 5, 10, 20, 50, 100];
  const token = localStorage.getItem("token");
  const [searchInputs, setSearchInputs] = useState({
    phone: "",
    address: "",
    date: "",
    name: "",
    action: "",
  });

  const [isSlotLoading, setSlotLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [reasonDialogOpen, setReasonDialogOpen] = useState(false);
  const [allSlots, setAllSlots] = useState([]);
  const [selectedReason, setSelectedReason] = useState("");

  const handleClose = () => {
    setSlotModalView(false);
  };

  // const fetchAllSlots = async (page = 1, limit = 20) => {
  //   try {
  //     const response = await axios.get(
  //       `${serverURL}/installationPartner/viewAllAssignedSlots?page=${page}&limit=${limit}`,
  //       {
  //         headers: { Authorization: `Bearer ${token}` },
  //       }
  //     );

  //     if (response?.data?.success) {
  //       let fetchedData = response?.data?.data;

  //       // Decrypt phone numbers
  //       let decrData = fetchedData.map((slot) => ({
  //         ...slot,
  //         phoneNumber: slot.phoneNumber ? Decrypt(slot.phoneNumber) : null,
  //       }));

  //       setAllSlots(fetchedData);
  //       setTotalPages(response?.data?.totalPages);
  //       setSlotLoading(false);
  //     } else {
  //       setSlotLoading(false);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching slots:", error);
  //     setSlotLoading(false);
  //   }
  // };

  const fetchAllSlots = async (page = 1, limit = 20) => {
    try {
      const response = await axios.get(
        `${serverURL}/installationPartner/viewAllAssignedSlots?page=${page}&limit=${limit}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      if (response?.data?.success) {
        oldData = response?.data?.data;

        setAllSlots(response?.data?.data);
        setTotalPages(response?.data?.totalPages);
        setSlotLoading(false);
      } else {
        setSlotLoading(false);
      }
    } catch (error) {
      console.error("Error fetching slots:", error);
      setSlotLoading(false);
    }
  };

  useEffect(() => {
    fetchAllSlots(page, pageSize);
  }, [page, pageSize]);
  const handlePageChange = async (e, value) => {
    await fetchAllSlots(value, pageSize);
    setPage(value);
  };

  const handlePageSizeChange = (event) => {
    setPageSize(parseInt(event.target.value));
    setPage(1);
  };

  const setSelectedRow = async (ele) => {
    try {
      const response = await axios.patch(
        `${serverURL}/installationPartner/edit/${ele._id}`,
        {
          isTestPassed: (ele.isTestPassed = "passed"),
          testPassedBy: localStorage.getItem("userId"),
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      if (response.data.success) {
        fetchAllSlots();
      }
    } catch (error) {
      console.error("Error in update installation partner", error);
    }
  };
  const [formData, setFormData] = useState({});
  const fileInputRefs = React.useRef({}); // Store refs for each row

  const handleFileInputRef = (id) => {
    if (!fileInputRefs.current[id]) {
      fileInputRefs.current[id] = React.createRef();
    }
    return fileInputRefs.current[id];
  };

  const [rowUploading, setRowUploading] = React.useState(null); // Holds the ID of the row being uploaded

  const handleUpload = async (e, id) => {
    const file = e.target.files[0];
    setRowUploading(id); // Set the current row as uploading

    if (file) {
      if (file.size > 2 * 1024 * 1024) {
        Swal.fire({
          customClass: {
            container: "my-swal",
          },
          icon: "error", // Type of alert
          title: "File Too Large",
          text: "The file size exceeds the maximum limit of 2MB. Please upload a smaller file.",
          confirmButtonText: "OK",
        });

        setRowUploading(null); // Reset the uploading state
        return;
      }

      const formDataNew = new FormData();
      formDataNew.append("files", file);

      try {
        const token = localStorage.getItem("token");
        const uploadResponse = await axios.post(
          `${process.env.REACT_APP_URL}/upload`,
          formDataNew,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          },
        );

        if (uploadResponse.data.success) {
          const fileUrl = uploadResponse.data.data[0];
          const patchResponse = await axios.patch(
            `${process.env.REACT_APP_URL}/installationPartner/edit/${id}`,
            {
              documentForTest: fileUrl,
            },
            {
              headers: { Authorization: `Bearer ${token}` },
            },
          );

          if (patchResponse.data.success) {
            fetchAllSlots(); // Refresh the data after success
          }
        }
      } catch (error) {
        Swal.fire({
          customClass: {
            container: "my-swal",
          },
          icon: "error", // Type of alert
          text: "Error during upload File.",
          confirmButtonText: "OK",
        });

        console.error("Error during upload or patch process", error);
      } finally {
        setRowUploading(null); // Reset the uploading state after completion
      }
    }
  };

  const setRejectedTest = async (ele, rejectionReason) => {
    try {
      const response = await axios.patch(
        `${serverURL}/installationPartner/edit/${ele._id}`,
        {
          isTestPassed: (ele.isTestPassed = "rejected"),
          testPassedBy: localStorage.getItem("userId"),
          rejectionReason: rejectionReason,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      if (response.data.success) {
        fetchAllSlots();
      }
    } catch (error) {
      console.error("Error in update installation partner", error);
    }
  };
  const handleSearchChangeHead = (e, key) => {
    const value = e.target.value;
    const searchTerm = value.trim().replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    const searchKeyword = new RegExp(`\\b${searchTerm}\\w*\\b`, "i");

    // Update search inputs state for that particular field
    setSearchInputs((prevState) => ({
      ...prevState,
      [key]: value,
    }));

    // Check if the input is empty and reset the data to oldData
    if (value === "") {
      setAllSlots(oldData);
    } else {
      // Apply filtering based on the column (key)
      const filteredData = oldData.filter((data) => {
        const date = new Date(data.slotId.dateForSlot); // Convert timestamp to date
        const formattedDate = date.toLocaleDateString(); // Format as "MM/DD/YYYY"

        // For each case, check if the key matches and perform filtering
        switch (key) {
          case "address":
            return searchKeyword.test(
              data?.slotId.address?.toLowerCase() ||
                data?.slotId.city?.toLowerCase(),
            );

          case "name":
            return searchKeyword.test(
              data?.installationPartnerId.name?.toLowerCase(),
            );

          case "date":
            return searchKeyword.test(formattedDate);

          case "phone":
            // Decrypt the phone number for searching
            const decryptedPhone = data?.installationPartnerId?.phoneNumber
              ? Decrypt(data.installationPartnerId.phoneNumber)
              : "";
            return searchKeyword.test(decryptedPhone);

          case "action":
            return searchKeyword.test(
              data?.installationPartnerId?.isTestPassed,
            );

          default:
            return true;
        }
      });

      setAllSlots(filteredData); // Update the InstallationPartner with the filtered data
    }
  };

  return (
    <div>
      <Dialog
        open={slotModalView}
        maxWidth="xl"
        // fullScreen
        // fullWidth
      >
        <div className="flex justify-between  ">
          <DialogTitle>Assigned Slots: {allSlots.length || 0}</DialogTitle>
          <div
            onClick={handleClose}
            className="mx-5 my-4"
            style={{ cursor: "pointer" }}
          >
            <Cross />
          </div>
        </div>
        <DialogContent>
          <div className="bg-white">
            <Box>
              <Paper sx={{ width: "100%" }}>
                <>
                  <TableContainer
                    sx={{
                      height: "calc(85vh - 150px)", // Adjust this to control available space for the table
                      maxHeight: "calc(85vh - 150px)", // Ensures the table won't exceed this height
                      overflowY: "auto", // Adds scroll when the content exceeds height
                      width: "full",
                    }}
                    className={` rounded-lg  ${Styles["custom-scrollbar"]}`}
                  >
                    <Table
                      stickyHeader
                      // sx={{ minWidth: 750 }}
                      className="rounded-lg "
                    >
                      <TableRow className="relative border rounded-sm">
                        {columns.map((headCell, index) => (
                          <TableCell
                            key={headCell.id}
                            className={styles.tableCell}
                            sx={{
                              minWidth: headCell.width,
                            }}
                            // sx={{
                            //   minWidth: headCell.width,
                            //   height: 90,
                            //   backgroundColor: "var(--light-primary-color)",
                            //   fontWeight: "semiBold",
                            //   borderRight:
                            //     index < headCell.width - 1
                            //       ? "1px solid #ccc"
                            //       : "none",
                            // }}
                          >
                            <span className="absolute top-2">
                              {" "}
                              {headCell.headerName}{" "}
                            </span>
                            <div className={styles.topBorderDiv}>
                              {["address", "name", "phone", "action"].includes(
                                headCell.field,
                              ) && (
                                <input
                                  type="text"
                                  className={styles.searchInput}
                                  // className="px-3 w-full py-1 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 mt-2"
                                  placeholder={`Search `}
                                  onChange={(e) =>
                                    handleSearchChangeHead(e, headCell.field)
                                  } // Use the handler passed via props
                                  value={searchInputs?.[headCell.field] || ""} // Access search inputs from props
                                />
                              )}
                            </div>
                          </TableCell>
                        ))}
                      </TableRow>
                      {!isSlotLoading ? (
                        allSlots && allSlots?.length > 0 ? (
                          <TableBody>
                            {allSlots?.map((v, index) => {
                              return (
                                <TableRow
                                  hover
                                  sx={{
                                    height: "60px",
                                  }}
                                  tabIndex={-1}
                                  key={v?._id}
                                >
                                  <TableCell className={styles.tableRow}>
                                    <span>{index + 1 || "N/A"}</span>
                                  </TableCell>
                                  <TableCell className={styles.tableRow}>
                                    <span>
                                      <FormatTimestamp
                                        timestamp={v.slotId.dateForSlot}
                                      />
                                    </span>
                                  </TableCell>
                                  <TableCell className={styles.tableRow}>
                                    <span>
                                      {v?.slotId?.slotTimeFrom || "N/A"}
                                    </span>
                                  </TableCell>
                                  <TableCell className={styles.tableRow}>
                                    <span>
                                      {v?.slotId?.slotTimeTo || "N/A"}
                                    </span>
                                  </TableCell>
                                  {/* <TableCell className={styles.tableRow}>
                                    <span className="block">{v?.slotId?.address}</span>
                                    <span className="text-gray-400 text-xs">
                                      {" "}
                                      {v?.slotId?.city},{v?.slotId?.state},
                                      {v?.slotId?.zipCode}
                                    </span>
                                  </TableCell > */}
                                  <TableCell className={styles.tableRow}>
                                    {(() => {
                                      const fullAddress = ` ${v?.slotId?.city}, ${v?.slotId?.state}, ${v?.slotId?.zipCode}`;

                                      // Truncate if length > 15
                                      const truncatedAddress =
                                        fullAddress.length > 15
                                          ? fullAddress.slice(0, 15) + "..."
                                          : fullAddress;

                                      return (
                                        <>
                                          <Tooltip
                                            title={`${v?.slotId?.address} ${fullAddress}`}
                                            arrow
                                            placement="top"
                                          >
                                            <span className="block">
                                              {`${v?.slotId?.address} ${fullAddress}`
                                                .length > 17
                                                ? `${`${v?.slotId?.address} ${fullAddress}`.substring(
                                                    0,
                                                    17,
                                                  )}...`
                                                : `${v?.slotId?.address} ${fullAddress}`}
                                            </span>
                                          </Tooltip>
                                        </>
                                      );
                                    })()}
                                  </TableCell>
                                  <TableCell className={styles.tableRow}>
                                    <span>
                                      {v?.installationPartnerId ? (
                                        <Tooltip
                                          title={CapitalizeFirstLetter(
                                            v?.installationPartnerId?.name ||
                                              "",
                                          )}
                                          arrow
                                          placement="top"
                                        >
                                          <span>
                                            {CapitalizeFirstLetter(
                                              v?.installationPartnerId?.name
                                                ?.length > 10
                                                ? v.installationPartnerId.name.slice(
                                                    0,
                                                    7,
                                                  ) + "..."
                                                : v.installationPartnerId
                                                    .name || "N/A",
                                            )}
                                          </span>
                                        </Tooltip>
                                      ) : (
                                        "N/A"
                                      )}
                                    </span>
                                  </TableCell>
                                  <TableCell className={styles.tableRow}>
                                    <span>
                                      {v?.installationPartnerId
                                        ?.aadhaarCardNumber || "N/A"}
                                    </span>
                                  </TableCell>
                                  <TableCell className={styles.tableRow}>
                                    <span
                                      style={{
                                        display: "inline-block",
                                        maxWidth: "78px", // Set a fixed width for ellipsis
                                        overflow: "hidden",
                                      }}
                                    >
                                      {Decrypt(
                                        v?.installationPartnerId?.phoneNumber,
                                      ) || "N/A"}
                                    </span>
                                  </TableCell>
                                  <TableCell className={styles.tableRow}>
                                    <span>
                                      {v?.installationPartnerId?.gender ||
                                        "N/A"}
                                    </span>
                                  </TableCell>
                                  <TableCell className={styles.tableRow}>
                                    {v?.installationPartnerId
                                      ?.documentForTest ? (
                                      <span>
                                        <a
                                          href={
                                            v.installationPartnerId
                                              .documentForTest
                                          } // The document URL
                                          target="_blank" // Open in a new tab
                                          rel="noopener noreferrer" // Security best practice
                                          className="text-sm text-blue-500 hover:underline"
                                        >
                                          View Certificate
                                        </a>
                                      </span>
                                    ) : rowUploading ===
                                      v?.installationPartnerId?._id ? (
                                      <span className="text-sm text-gray-500 font-semibold">
                                        Uploading...
                                      </span>
                                    ) : (
                                      <>
                                        <GlobalButton
                                          size="medium"
                                          variant="primary"
                                          onClick={() => {
                                            const ref = handleFileInputRef(
                                              v.installationPartnerId._id,
                                            ); // Get the specific ref
                                            if (ref.current) {
                                              ref.current.value = ""; // Reset the input value
                                              ref.current.click(); // Trigger the file input
                                            }
                                          }}
                                        >
                                          {`Upload`}
                                        </GlobalButton>
                                        <input
                                          type="file"
                                          accept="application/pdf" // Allow only PDF files
                                          ref={handleFileInputRef(
                                            v?.installationPartnerId?._id,
                                          )} // Assign a unique ref
                                          style={{ display: "none" }} // Hide the input element
                                          onChange={(e) =>
                                            handleUpload(
                                              e,
                                              v?.installationPartnerId?._id,
                                            )
                                          } // Call the upload function
                                        />
                                      </>
                                    )}
                                  </TableCell>

                                  <TableCell className={styles.tableRow}>
                                    {v?.installationPartnerId?.isTestPassed ===
                                    "passed" ? (
                                      <p className="text-center font-semibold text-[14px] text-green-800">
                                        Pass
                                      </p>
                                    ) : v?.installationPartnerId
                                        ?.isTestPassed === "rejected" ? (
                                      <>
                                        <p className="text-center font-semibold ">
                                          <span>
                                            <BlockIcon
                                              color="error"
                                              fontSize="small"
                                            />
                                          </span>{" "}
                                          <span className="text-[var(--error-color)] text-[12px]">
                                            Reject
                                          </span>{" "}
                                          <span>
                                            <Tooltip title="Click to view reason">
                                              <IconButton
                                                onClick={() => {
                                                  setSelectedReason(
                                                    v.installationPartnerId
                                                      ?.rejectionReason ?? "",
                                                  );
                                                  setReasonDialogOpen(true);
                                                }}
                                              >
                                                <MoreVert fontSize="small" />
                                              </IconButton>
                                            </Tooltip>
                                          </span>
                                        </p>
                                        <IpReasonDialog
                                          open={reasonDialogOpen}
                                          onClose={() =>
                                            setReasonDialogOpen(false)
                                          }
                                          reason={selectedReason} // Ensure it's never undefined
                                        />
                                      </>
                                    ) : (
                                      <div className="flex gap-2">
                                        <Button
                                          variant="contained"
                                          color="success"
                                          className="text-sm"
                                          onClick={() => {
                                            setSelectedRow(
                                              v.installationPartnerId,
                                            );
                                          }}
                                        >
                                          {"Passed"}
                                        </Button>
                                        <GlobalButton
                                          variant="contained"
                                          color="error"
                                          className="text-sm "
                                          onClick={() => setDialogOpen(true)}
                                        >
                                          {"Rejected"}
                                        </GlobalButton>

                                        <IpRejectDialog
                                          open={dialogOpen}
                                          onClose={() => setDialogOpen(false)}
                                          setDialogOpen={setDialogOpen}
                                          onSubmit={(rejectionReason) =>
                                            setRejectedTest(
                                              v.installationPartnerId,
                                              rejectionReason,
                                            )
                                          }
                                        />
                                      </div>
                                    )}
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                          </TableBody>
                        ) : (
                          <TableRow>
                            <TableCell colSpan={columns?.length}>
                              <div className="flex justify-center items-center h-64">
                                No assigned slots found
                              </div>
                            </TableCell>
                          </TableRow>
                        )
                      ) : (
                        <div className="flex justify-center items-center h-64">
                          <CircularProgress />
                        </div>
                      )}
                    </Table>
                  </TableContainer>
                  <hr
                    className="mt-2 bg-gray-200 "
                    style={{ border: "0.5px solid var(--light-grey-color)" }}
                  />

                  <div className="flex items-center justify-between mx-3 mt-3">
                    <FormControl
                      variant="standard"
                      size="small"
                      sx={{ minWidth: 80 }}
                    >
                      <InputLabel id="page-size-label">Rows</InputLabel>
                      <Select
                        labelId="page-size-label"
                        value={pageSize}
                        onChange={handlePageSizeChange}
                        label="Rows"
                      >
                        {pageSizeOptions.map((size) => (
                          <MenuItem key={size} value={size}>
                            {size}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <Pagination
                      className="p-2 flex justify-center"
                      count={totalPages}
                      page={page}
                      onChange={handlePageChange}
                      sx={{
                        "& .MuiPaginationItem-root.Mui-selected": {
                          backgroundColor: "#418cff", // Blue background for selected
                          color: "#fff", // White text for selected
                        },
                        "& .MuiPaginationItem-root.Mui-selected:hover": {
                          backgroundColor: "#3366cc", // Darker blue on hover
                        },
                        "& .MuiPaginationItem-root": {
                          "&:hover": {
                            backgroundColor: "#ddd", // Light gray for hovered items
                          },
                        },
                      }}
                    />
                  </div>
                </>
              </Paper>
            </Box>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default ViewSlotsInstallationPartner;
